import React, { useContext } from 'react';
import { TabContext } from './TabProvider';

const TabContent = () => {
    const { activeTab } = useContext(TabContext);
    return <div>{activeTab?.component ?? null}</div>;
};

export default TabContent;
